// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__251io","loaderOuter":"PageOverlayLoader_loaderOuter__11IPQ"};